import { Controller } from "./core/Controller";

export default class Cache
{

    static prefix = "aviator_";


    private static _key(key: string)
    {
        return this.prefix + Controller.player + "_" + key;
    }


    static get(key: string): string
    {
        try
        {
            return localStorage.getItem(this._key(key));
        }
        catch(e)
        {
            return null;
        }
    }


    static set(key: string, value: string)
    {
        try
        {
            localStorage.setItem(this._key(key), value);
        }
        catch(e)
        {

        }
    }


    static getJson(key: string)
    {
        const val = this.get(key);
        if (val)
        {
            return JSON.parse(val);
        }

        return val;
    }


    static setJson(key: string, value: any)
    {
        this.set(key, JSON.stringify(value))
    }


}

// @ts-ignore
window.Cache = Cache;